//
// This service is a layer providing information about customizable parts of the UI.
// It can define, for example, a list of configurable custom columns for various tables/grids in the UI.
//

import { Injectable } from '@angular/core'
import { ColumnConfigService } from '../../services/column-config.service'
import { Observable, of } from 'rxjs'
import { map, catchError } from 'rxjs/operators'
import { customizableDataSources, DataSource } from './customizable-data-sources'

export type TargetControl = string

@Injectable({
  providedIn: 'root',
})
export class CustomUiService {
  constructor(protected columnConfigService: ColumnConfigService) {}

  /**
   * Returns a definition of available custom columns for given target control.
   * @param targetControl
   * @returns {DataSource[]}
   */
  getAvailableCustomColumns(targetControl: TargetControl) {
    return customizableDataSources[targetControl] || []
  }

  /**
   * Returns configured custom columns for given target control.
   * @param targetControl
   * @return {Observable<DataSource[]>}
   */
  getConfiguredCustomColumns(targetControl: TargetControl): Observable<DataSource[]> {
    return this.columnConfigService
      .getForControl(targetControl)
      .pipe(
        map((columnLayout) =>
          customizableDataSources[targetControl].filter((dataSource) => columnLayout.includes(dataSource.id)),
        ),
        catchError((error) => {
          console.error(`Error loading configured custom columns for ${targetControl}:`, error)
          // Return empty array as fallback to prevent component from breaking
          return of([])
        })
      )
  }
}
